import React from 'react';

/**
 * A simple wrapper component what could help us to render based on conditions.
 */

const DisplayContent = ({ isVisible, children }) => {
    return isVisible ? <>{children}</> : null;
};

DisplayContent.defaultProps = {
    children: null,
};

export default DisplayContent;
